/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsProcess: {
  name: 'process';
  data: string;
} = {
  name: 'process',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2v2.682c.148.085.288.191.414.318L19 15.586a2 2 0 0 1 0 2.828L17.414 20a2 2 0 0 1-2.828 0L13 18.414a2.002 2.002 0 0 1-.318-.414H8.829a3.001 3.001 0 1 1 0-2h3.853c.085-.148.191-.287.318-.414L14.586 14c.127-.127.266-.233.414-.318V11h-2a2 2 0 0 1-2-2V8H8.83a3.001 3.001 0 1 1 0-2H11V5ZM7 7a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm6 0v2h6V5h-6v2Zm-7 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm10-.586L14.414 17 16 18.586 17.586 17 16 15.414Z" fill="currentColor"/></svg>`,
};
